import { render, staticRenderFns } from "./NeedsAttentionCard.vue?vue&type=template&id=4c19e98e&scoped=true"
import script from "./NeedsAttentionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NeedsAttentionCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NeedsAttentionCard.vue?vue&type=style&index=0&id=4c19e98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c19e98e",
  null
  
)

export default component.exports